module.exports = __webpack_public_path__ + "static/media/qui-sommes-nous-2.851c23e9.jpg";